export default "__VITE_ASSET__2eab4a5a__"